import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import { cookie } from '@ifeng/ui_base';
import errorBoundary from '@ifeng/errorBoundary';
import NewsTitle from '../../../components/newsTitle';
import Fiction from './fiction';
import FictionExtra from './fictionExtra';

class CenterNewsBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        prov: null,
    };

    componentDidMount() {
        let prov = null;

        try {
            if (typeof document !== 'undefined') {
                prov = cookie.get('prov') && cookie.get('prov') !== '' ? cookie.get('prov') : null;
            }

            if (typeof window !== 'undefined') {
                const path = window.location.href;

                // 地方站预览逻辑
                if (
                    (path.indexOf('visualediting') > -1 || path.indexOf('preview') > -1) &&
                    path.indexOf('extra') > -1
                ) {
                    prov = null;
                }
            }

            this.setState({
                prov,
            });
        } catch (e) {
            console.error(e);
        }
    }

    render() {
        const { prov } = this.state;
        const {
            content: { fictionTitle, fictionList, fictionBox, fictionAreaList, fictionAreaBox },
        } = this.props;

        const unExtra = prov === 'cn010' || prov === 'cn0311';

        return (
            <div className={styles.center_box}>
                <Chip id="200147" type="struct" title="小说标题" groupName="小说" content={fictionTitle}>
                    <NewsTitle size="middle" />
                </Chip>
                {unExtra ? (
                    <Fiction
                        content={{
                            fictionList,
                            fictionBox,
                        }}
                    />
                ) : (
                    <FictionExtra
                        content={{
                            fictionAreaList,
                            fictionAreaBox,
                        }}
                    />
                )}
            </div>
        );
    }
}

export default errorBoundary(CenterNewsBox);
